<template>
    <div class="flex items-center h-full">
        <vs-chip 
          :color="chipSettings.color"
          :transparent="chipSettings.transparent"
          size="small"
          class="h-4 w-full"
        > {{ label }}</vs-chip>
      </div>
  </template>
  
  <script>
  import Vue from 'vue'
  
  export default Vue.extend({
    data () {
      return {
        label: '',
        completed: false,
        chipSettings: {
          transparent: true,
          color: 'dark',
          text: '-'
        }
      }
    },
    beforeMount () {
      const {label, completed, transparent} = this.params.value
      this.label = label
      this.completed = completed
      this.chipSettings.transparent = transparent

      this.setChipColor()
    },
    methods: {
      setChipColor(){
        if(this.completed){
          this.chipSettings.color = 'success'
        }else{
          this.chipSettings.color = 'warning'
        }
      }
    }
  })
  </script>